import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ClipboardPopupComponent } from './clipboard-popup.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MbI18nModule } from '../../../translations/mb-i18n.module'

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MbI18nModule],
  declarations: [ClipboardPopupComponent],
  exports: [ClipboardPopupComponent],
})
export class ClipboardPopupModule { }
